import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Consignment from "@/components/Consignment";

const FAQ = [
  {
    q: "What kinds of items do you accept?",
    a: "Autographed Funko Pops, signed sports & entertainment memorabilia, trading cards and TCG, comics, and full collections. If it's collectible and in demand, we want to see it.",
  },
  {
    q: "How does consignment payout work?",
    a: "You set a reserve. We list and sell your item across Whatnot, TikTok and eBay to 50,000+ buyers. Once it sells, you're paid your agreed share fast — no upfront fees to get started.",
  },
  {
    q: "Do you authenticate items?",
    a: "Yes. Every high-end piece is Witnessed OR Authenticated. We handle COAs, in-person witnessing and grading coordination where applicable.",
  },
  {
    q: "How do I send my items in?",
    a: "Submit the form below with photos and details. Our consignment team reviews it and reaches out within 48 hours with shipping instructions and next steps.",
  },
];

export default function ConsignPage() {
  return (
    <main data-testid="consign-page" className="bg-[#050505] text-white min-h-screen">
      {/* Page hero */}
      <section className="relative pt-32 md:pt-40 pb-8 md:pb-12 overflow-hidden">
        <div className="pointer-events-none absolute -top-24 left-0 h-[420px] w-[420px] rounded-full bg-[#3FE1D1]/10 blur-[150px]" />
        <div className="w-full max-w-[1440px] mx-auto px-6 md:px-12">
          <motion.span
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-xs uppercase tracking-[0.3em] text-[#3FE1D1] font-medium"
          >
            Consign With Monthly Pops
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="mt-4 font-display font-extrabold uppercase tracking-tighter text-white text-5xl md:text-7xl lg:text-8xl leading-[0.88]"
          >
            Your grails,<br />
            <span className="text-[#3FE1D1]">our stage.</span>
          </motion.h1>
          <p className="mt-6 max-w-xl text-white/60 text-base md:text-lg leading-relaxed">
            The longest-running auctioneer on Whatnot will sell your collection to
            50,000+ active buyers. Submit your items below and our team reaches out
            within 48 hours.
          </p>
        </div>
      </section>

      {/* Form (reuses the consignment component) */}
      <Consignment />

      {/* FAQ */}
      <section className="w-full max-w-[900px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <h2 className="font-display font-extrabold uppercase tracking-tighter text-white text-3xl md:text-5xl leading-none mb-10">
          Questions? <span className="text-[#3FE1D1]">Answered.</span>
        </h2>
        <Accordion type="single" collapsible className="w-full" data-testid="consign-faq">
          {FAQ.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10">
              <AccordionTrigger className="text-left font-display text-lg md:text-xl text-white hover:text-[#3FE1D1] hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/60 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </main>
  );
}
